import { AdyenPaymentMethod, PaymentMethod } from '@appliedsystems/payments-core';
import { datadogLogs } from '@datadog/browser-logs';
import { AvailablePaymentMethod } from 'src/components/HostedPaymentPageContainer/types';

export function getAppliedPaymentMethod(adyenPaymentMethod: string) {
  if (adyenPaymentMethod === AdyenPaymentMethod.Eft) {
    return PaymentMethod.Eft;
  }
  if (adyenPaymentMethod === AdyenPaymentMethod.Ach) {
    return PaymentMethod.Ach;
  }
  if (adyenPaymentMethod === AdyenPaymentMethod.Card) {
    return PaymentMethod.Card;
  }

  // should never happen
  datadogLogs.logger.error(`Unrecognized adyen payment method = ${adyenPaymentMethod} identified`);
  return adyenPaymentMethod as AvailablePaymentMethod;
}
